import { getIdReduxUtil } from '../get-id'
import isTemporaryIdReduxUtil from '../is-temporary-id'

function isNewReduxUtil (instance) {
  const id = getIdReduxUtil(instance)
  return !id || isTemporaryIdReduxUtil(id)
}

export default isNewReduxUtil
